import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult, Loaded, Loading, ServerError} from 'Core/models/Async';
import RatingAPI from 'Quoting/api/RatingAPI';
import {changeRatingDetails, RatingDetailsActionType} from 'Quoting/ducks/ratings';
import {A360ProductModel} from 'Quoting/models/Quoting';
import {isRight} from 'fp-ts/lib/Either';
import {fromJS} from 'immutable';
import {all, call, put, takeLatest} from 'redux-saga/effects';

interface GetRatingDetailsAction {
  type: string;
  payload: {
    modelName: A360ProductModel;
    policyNumber: string;
    packageCd: string;
  };
}

function* fetchRatingData(action: GetRatingDetailsAction) {
  const {modelName, policyNumber, packageCd} = action.payload;
  const errorMessage = 'Error: Could not fetch rating details!';
  try {
    yield put(changeRatingDetails(new Loading()));

    const response: AsyncResult<any> = yield call(RatingAPI.getRatingDetails, modelName, policyNumber, packageCd);

    if (isRight(response)) {
      const ratingDetails = response.right;
      yield put(changeRatingDetails(new Loaded(fromJS(ratingDetails))));
    } else {
      yield put(changeRatingDetails(new ServerError(errorMessage)));
    }
  } catch (error) {
    console.error(error);
    yield put(changeRatingDetails(new ServerError(errorMessage)));
    yield put(createSnackbar(errorMessage));
  }
}

function* fetchRatingDataSaga() {
  yield takeLatest(RatingDetailsActionType.GET_RATING_DETAILS, fetchRatingData);
}
export default function* ratingDetailsSaga() {
  yield all([fetchRatingDataSaga()]);
}
